<template>
  <div class="newLogin">
    <div class="logo-box">
      <img class="logo" src="../../assets/img/logo-weicaishui.png" alt="">
    </div>
    <div class="login-main">
      <div class="login-main-bg">

      </div>
      <div class="login-main-form-container">
        <div class="circle"></div>
        <h3 class="login-form-title">登录</h3>
        <pwd-login :loginMethod.sync="loginMethod"></pwd-login>
      </div>
    </div>

<!--    <img class="logo-form" src="../../assets/img/login-formbg.png" alt="">-->
<!--    <div class="logo-form">-->
<!--      <img class="logo" src="../../assets/img/logo-new.png" alt="">-->
<!--      <img class="logo-form1" src="../../assets/img/login-formbg.png" alt="" style="visibility: hidden">-->
<!--      <div id="box2">-->
<!--        <h2>请登录您的账户</h2>-->
<!--        <p>Login to access your account</p>-->
<!--        <pwd-login :loginMethod.sync="loginMethod"></pwd-login>-->
<!--      </div>-->
<!--    </div>-->
<!--    <img class="bg" src="../../assets/img/login-bg.png" alt="">-->
  </div>
</template>

<script>
import { setRem } from "@/util/commen.js";
import pwdLogin from "./pwdlogin";

export default {
  name: "codelogin",
  components: { pwdLogin },
  data() {
    return {
      loginMethod: "code"
    };
  },
  created() {
    setRem();
  },
  mounted() {
  },
  computed: {},
  props: [],
  methods: {}
};
</script>
<style lang="scss" scoped>
  .newLogin ::v-deep .el-input .el-input__inner {
    color: #606266 !important;
  }
  .newLogin {
    background: #DA5651;
    height: 100%;
    padding: 0 0.84rem;
    .logo-box {
      height: 0.76rem;
      display: flex;
      align-items: center;
      .logo {
        height: 0.44rem;
      }
    }
    .login-main {
      height: 7.9rem;
      display: flex;
      justify-content: space-between;
      .login-main-bg {
        width: 11.4rem;
        height: 100%;
        background: url("../../assets/img/taxCloud/login-formbg-taxcloud.png") no-repeat;
        background-size: cover;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: rgba(0,0,0,0.35) 22px 0 35px;
      }
      .login-main-form-container {
        overflow: hidden;
        width: 5.66rem;
        padding: 0.5rem 0.64rem 0 0.46rem;
        height: 100%;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 20px;
        position: relative;
        .circle {
          position: absolute;
          width: 2.25rem;
          height: 2.27rem;
          top: -0.8rem;
          right: -0.8rem;
          background: url("../../assets/img/login-form-circle-weicaishui.png") no-repeat;
          background-size: 100%;
        }
        .login-form-title {
          height: 1.42rem;
          line-height: 1.42rem;
          font-size: 0.56rem;
          color: #C73122;
        }
      }
    }
  }
</style>
